import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ChargingUserService } from 'src/app/shared/services/charging-user.service';
import { SnackbarService, FeedbackInfoComponent } from 'ok-angular-shared/components';
import { AppInvitationsSearchEvent, ChargingUser, ChargingUserAppInvitation } from '../charging-user.model';
import { ChargingUserAddIdtaginfoModalComponent } from '../charging-user-add-id-tag-info-modal/charging-user-add-id-tag-info-modal.component';
import { FormControl, FormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { PagingOptions } from 'src/app/shared/models/paging';
import { BehaviorSubject, debounceTime, distinctUntilChanged, firstValueFrom, take } from 'rxjs';
import { AppInvitationStatus } from 'src/app/shared/enums/app-invitation-status.enum';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { LoadingSpinnerComponent } from '../../../core/loading-spinner/loading-spinner.component';
import { TranslateAppInvitationStatusEnum } from '../../../shared/pipes/translate-app-invitation-status-enum.pipe';
import { SendNewChargingUserInvitationComponent } from '../send-app-invitation-modal/send-new-invitation.component';
import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { PagerBase } from 'src/app/shared/models/pagerBase';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  MatTable,
  MatHeaderCell,
  MatCell,
  MatHeaderRow,
  MatRow,
  MatColumnDef,
  MatHeaderCellDef,
  MatCellDef,
  MatHeaderRowDef,
  MatRowDef,
} from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { DatePipe, AsyncPipe } from '@angular/common';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'adm-charging-user-app-invitations-modal',
  templateUrl: './app-invitations-modal.component.html',
  styleUrl: './app-invitations-modal.component.scss',
  imports: [
    LoadingSpinnerComponent,
    TranslateAppInvitationStatusEnum,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIcon,
    MatButton,
    MatTable,
    MatHeaderCell,
    MatCell,
    MatHeaderRow,
    MatRow,
    MatColumnDef,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatRowDef,
    MatPaginator,
    MatSort,
    MatSortHeader,
    MatMenu,
    MatIconButton,
    MatMenuItem,
    MatMenuTrigger,
    MatTooltip,
    DatePipe,
    AsyncPipe,
    CommonModule,
    FeedbackInfoComponent,
  ],
})
export class ChargingUserAppInvitationsModalComponent extends PagerBase implements OnInit {
  data = inject<{
    chargingUser;
  }>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<ChargingUserAddIdtaginfoModalComponent>>(MatDialogRef);
  private chargingUserService = inject(ChargingUserService);
  private snackbarService = inject(SnackbarService);
  private dialog = inject(MatDialog);

  public addressFoundAndSelected = false;
  public chargingUser: ChargingUser;
  public appInvitationsFilterModel: FormGroup<AppInvitationsFilterModel>;
  public appInvitationsSearchEvent: AppInvitationsSearchEvent;
  public appInvitations: ChargingUserAppInvitation[] = [];
  public statuses = AppInvitationStatus;
  public pageEvent = new PageEvent();
  public appInvitationsCount: number;
  public currentPage: number;
  public pagingOptions: PagingOptions;
  public loading$ = new BehaviorSubject<boolean>(false);
  public sending$ = new BehaviorSubject<boolean>(false);

  data$: BehaviorSubject<ChargingUserAppInvitation[]>;
  dataSource: MatTableDataSource<ChargingUserAppInvitation> = new MatTableDataSource<ChargingUserAppInvitation>();
  public displayColumns = ['phoneNumber', 'organizationName', 'appInvitationStatus', 'deepLinkCreated', 'smsSent', 'edit'];

  ngOnInit() {
    this.chargingUser = this.data?.chargingUser;
    this.pageEvent.pageSize = this.defaultPageSize;
    this.appInvitationsSearchEvent = new AppInvitationsSearchEvent(this.pageEvent);
    this.appInvitationsSearchEvent.sorting = <Sort>{ active: 'SmsSent', direction: 'desc' };

    if (this.chargingUser) {
      this.appInvitationsSearchEvent.chargingUserIdentifier = this.chargingUser.identifier;
    } else {
      this.appInvitationsFilterModel = new FormGroup<AppInvitationsFilterModel>({
        query: new FormControl<string | null>(null),
        selectedAppInvitationStatus: new FormControl<AppInvitationStatus | null>(null),
      });

      this.appInvitationsFilterModel.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(async val => {
        this.loading$.next(true);
        this.appInvitationsSearchEvent.query = val.query;
        if (val.selectedAppInvitationStatus) {
          this.appInvitationsSearchEvent.appInvitationStatus = val.selectedAppInvitationStatus;
        } else {
          this.appInvitationsSearchEvent.appInvitationStatus = undefined;
        }
        this.loading$.next(true);
        this.getAppInvitations();
      });
    }
    this.getAppInvitations();
    this.initPaginator();
  }

  getAppInvitations() {
    this.loading$.next(true);
    this.chargingUserService.getAppInvitations(this.appInvitationsSearchEvent).subscribe({
      next: result => {
        this.dataSource.data = result.items;
        this.appInvitationsCount = result.totalCount;
        this.currentPage = result.pageIndex;
        this.data$ = this.dataSource.connect();
        this.appInvitations = result.items;
        this.loading$.next(false);
      },
      error: () => {
        this.snackbarService.error('Fejl ved hentning af invitationer');
        this.loading$.next(false);
      },
    });
  }

  public onPageChanged(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pagingOptions.pageSize = event.pageSize;
    this.appInvitationsSearchEvent.paging.pageIndex = event.pageIndex;
    this.getAppInvitations();
  }

  public sortData(sortEvent: Sort) {
    if (this.appInvitationsSearchEvent.paging) {
      this.appInvitationsSearchEvent.paging.pageIndex = 0;
    }
    if (sortEvent.direction === '') {
      sortEvent.direction = 'asc';
    }

    this.appInvitationsSearchEvent.sorting = sortEvent;
    this.getAppInvitations();
  }

  public consoleLogDeepLink(chargingUserAppInvitation: ChargingUserAppInvitation) {
    console.warn(chargingUserAppInvitation.deepLink);
  }

  public close() {
    this.dialogRef.close(this.chargingUser);
  }

  private initPaginator(): void {
    this.currentPage = 0;
    this.pagingOptions = {
      pageSize: this.pageEvent.pageSize,
      pageSizeOptions: this.pageSizes,
    };
  }

  public gotoSend() {
    const dialog = this.dialog.open(SendNewChargingUserInvitationComponent, {
      data: { chargingUser: this.chargingUser },
    });
    dialog
      .afterClosed()
      .pipe(take(1))
      .subscribe(() => {
        this.getAppInvitations();
      });
  }

  public SendQueuedInvitationNow(chargingUserAppInvitation: ChargingUserAppInvitation) {
    this.chargingUserService.sendQueuedInvitationNow(this.chargingUser.id, chargingUserAppInvitation.identifier).subscribe({
      next: () => {
        this.snackbarService.success('Invitation afsendt');
        this.getAppInvitations();
      },
      error: (httpError: HttpErrorResponse) => {
        if (httpError.status == HttpStatusCode.InternalServerError) {
          switch (httpError.error?.code) {
            case 101102:
              this.snackbarService.error(
                'Det var ikke muligt at planlægge afsendelse af invitationen, da brugerens telefonnummer er ugyldigt.'
              );
              break;
            case 101103:
              this.snackbarService.error(
                'Det var ikke muligt at planlægge afsendelse af invitationen, da formatet for brugerens telefonnummer er ugyldigt.'
              );
              break;
            default:
              this.snackbarService.error(`Der er sket en ukendt fejl: (${httpError.error?.message})`);
              break;
          }
        } else {
          this.snackbarService.error(`Der er sket en ukendt fejl: (${httpError.error?.message})`);
        }

        throw httpError;
      },
    });
  }

  public async reSend(chargingUserAppInvitation: ChargingUserAppInvitation) {
    this.sending$.next(true);
    await firstValueFrom(
      this.chargingUserService.sendAppInvitation(
        this.chargingUser.id,
        chargingUserAppInvitation.phoneNumber,
        chargingUserAppInvitation.phoneCountryCode
      )
    )
      .then(x => {
        this.snackbarService.success('Invitation afsendt');
        this.getAppInvitations();
      })
      .catch((httpError: HttpErrorResponse) => {
        if (httpError.status == HttpStatusCode.BadRequest) {
          switch (httpError.error?.code) {
            case 500022:
              this.snackbarService.error(`Invitationen mangler et branch.io deeplink, så sms'en blev ikke afsendt.`);
              break;
            case 101100:
              this.snackbarService.error('Mobilnummeret angivet er ikke et gyldigt telefonnummer for den indtastede landekode.');
              break;
            case 101101:
              this.snackbarService.error('Mobilnummeret er af et ugyldigt format for den indtastede landekode.');
              break;
            default:
              this.snackbarService.error(httpError.error?.message);
              break;
          }
        } else {
          this.snackbarService.error('Fejl ved afsendelse af invitation');
        }
      });
  }
}
interface AppInvitationsFilterModel {
  query: FormControl<string | null>;
  selectedAppInvitationStatus: FormControl<AppInvitationStatus | null>;
}
